/**
 * Save slots: `?slot=2` (or any name) plays a completely separate life in this tab, without touching
 * your main one. The slot sticks to the tab as you move between the creator and the street;
 * `?slot=main` (or a fresh tab without ?slot) is your normal save.
 */

// (dev only: the real game is one life per player, ended on purpose from Support → Your life)
const param = import.meta.env.DEV ? new URLSearchParams(location.search).get('slot') : null;
let slot = '';
try {
  if (param !== null) sessionStorage.setItem('lifesim.slot', param === 'main' ? '' : param);
  slot = import.meta.env.DEV ? sessionStorage.getItem('lifesim.slot') ?? '' : '';
} catch { slot = param && param !== 'main' ? param : ''; }
slot = slot.replace(/[^\w-]/g, '').slice(0, 24);

export const SLOT = slot;

/** The storage key for this slot (the main save keeps the original key names). */
export const slotKey = (key: string) => (SLOT ? `${key}.${SLOT}` : key);

if (SLOT) document.title = `${document.title} · ${SLOT}`;
